type Listener = () => void;

const listeners = new Set<Listener>();

/**
 * Announces that the gateway refused a request because the account's AI allowance is spent.
 * Kept free of imports so the chat stream can raise it without pulling in any UI.
 */
export const notifyAiCreditsExhausted = (): void => {
	listeners.forEach(listener => {
		try {
			listener();
		} catch {
			// A failing listener must not stop the others, nor break the chat that raised this.
		}
	});
};

export const subscribeAiCreditsExhausted = (listener: Listener): (() => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};
